/**
 * ReactFlow is open source and asks attribution to be displayed when
 * not paid for. We've started paying for ReactFlow and will be removing
 * the attribution.
 * https://dbt-labs.slack.com/archives/C0352PN4X89/p1658753981604889?thread_ts=1652813152.392509&cid=C0352PN4X89
 */
export const proOptions = {
  // passing in the account property will enable hiding the attribution
  account: 'paid-pro',
  // in combination with the account property, hideAttribution: true will remove the attribution
  hideAttribution: true,
};
